import { render, staticRenderFns } from "./AddImgJackpot.vue?vue&type=template&id=8131ac64&"
import script from "./AddImgJackpot.vue?vue&type=script&lang=js&"
export * from "./AddImgJackpot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports